import React from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
};

interface InputFilterProps {
  label: string;
  registerReturn: UseFormRegisterReturn;
  inputProps: InputProps;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputFilter: React.FC<InputFilterProps> = ({
  label,
  registerReturn,
  inputProps,
  onChange,
}) => {
  return (
    <div className="filterItem patientName">
      <div>
        <label className="txtDropdownLabel">{label}</label>
      </div>

      <div>
        <input {...registerReturn} {...inputProps} onChange={onChange} />
      </div>
    </div>
  );
};

export default InputFilter;
